import { ModalDialog } from '../../job-roles/components/ModalDialog';
import type { DashboardDetail } from '../dashboardTypes';
import { formatMoney } from '../format';

/** Confirms Retry Payment. The server decided it is allowed; this only asks first. In this staging build a retry is the existing SIMULATED reissue: it makes a new
 * simulated attempt and sends nothing to a bank. The status changes only from the server's answer. */
export function RetryPaymentDialog({ detail, busy, error, onCancel, onConfirm }: { detail: DashboardDetail; busy: boolean; error: string | null; onCancel: () => void; onConfirm: () => void }) {
  return (
    <ModalDialog
      title="Retry Payment" size="sm" role="alertdialog" busy={busy} onClose={onCancel}
      footer={(
        <>
          <button type="button" className="jr-btn jr-btn--secondary" disabled={busy} onClick={onCancel}>Cancel</button>
          <button type="button" className="jr-btn jr-btn--primary" data-autofocus disabled={busy} onClick={onConfirm}>{busy ? 'Retrying…' : 'Retry Payment'}</button>
        </>
      )}
    >
      <p>Create a new attempt for the {formatMoney(detail.row.amount)} payment?</p>
      <p className="tpd-muted">This is a simulation: a new simulated attempt is created and nothing is sent to a bank, payment provider or agency. The status changes only once the server confirms it.</p>
      {error && <p className="jr-error" role="alert" data-testid="retry-error">{error}</p>}
    </ModalDialog>
  );
}
